// Rails
require("@rails/ujs").start()
require("turbolinks").start()
import 'controllers'
import 'countdown.js'
import 'mathjax/es5/tex-chtml-full.js';
import '../modules/calculators.js';
import '../modules/linkedin_insight_navigation.js';

// CSS
import "stylesheets/application.scss";

// Functions
document.addEventListener("turbolinks:load", function() {
  // Scroll fix when changing layouts
  window.scrollTo(0, 0);

  // Enable buy button functionality in Course Buy Box (layout V2)
  const buyButton = document.getElementsByClassName('buy-button')
  Array.from(buyButton).forEach(function(button){
    button.addEventListener('click', function(e){
      e.preventDefault();
      const purchase_link = this.getAttribute('data-pricing-course-url');
      document.getElementById('action_with_subscription_form_redirect_to_url').setAttribute("value", purchase_link);
      document.getElementById('action_with_subscription_form_redirect_to_url').parentElement.submit();    
    })
  })

  // Allow reviews pagination and filtering without constant scrolling
  if (window.location.hash) {
    var element = document.getElementById(window.location.hash.substring(1));
    if (element) {
      element.scrollIntoView();
    }
  }
});
